import { paths } from "./paths";

export const meilisearchConfig = {};

export const logoutTimerConfig = {
  TIMEOUT_SEC: 600,
  EXCLUDE_PAGES: [
    paths.dashboard.monitoring,
    paths.auth.login,
    paths.auth.register,
  ],
};
